import React from 'react';
import { Link } from 'react-router-dom';
import { ApiRef } from '../fasades/apiref';
import './apinavigator.css';

interface Props {
    currentDocUrl?: string;
}

interface State {
    navTop: number;
}

export class ApiNavigator extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { navTop: 0 };
    }

    componentDidMount() {
        this.updateNavTop();
        window.addEventListener('resize', this.updateNavTop);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateNavTop);
    }

    updateNavTop = () => {
        const nav = document.querySelector('.nav');
        if (nav) {
            const height = nav.getBoundingClientRect().height;
            this.setState({ navTop: height });
        }
    }

    render() {
        const endpoints = ApiRef.getAllEndpoints();
        const currentPath = window.location.pathname;
        const currentDocUrl = this.props.currentDocUrl || currentPath.replace('/apiref/', '');

        return (
            <div className="api-navigator" style={{ top: `${this.state.navTop}px` }}>
                <h3 className="navigator-title">API Reference</h3>
                <nav className="navigator-list">
                    <Link
                        to="/apiref"
                        className={`navigator-item ${currentPath === '/apiref' ? 'active' : ''}`}
                    >
                        <div className="navigator-item-header">
                            <span className="navigator-item-title">Overview</span>
                        </div>
                    </Link>
                    <Link
                        to="/apiref/streaming"
                        className={`navigator-item ${currentPath === '/apiref/streaming' ? 'active' : ''}`}
                    >
                        <div className="navigator-item-header">
                            <span className="navigator-item-title">Streaming Guide</span>
                        </div>
                    </Link>
                    <h4 className="navigator-section-title">API Endpoints</h4>
                    {endpoints.map((endpoint, index) => {
                        const isActive = endpoint.docurl === currentDocUrl;
                        return (
                            <Link
                                key={index}
                                to={`/apiref/${endpoint.docurl}`}
                                className={`navigator-item ${isActive ? 'active' : ''}`}
                            >
                                <div className="navigator-item-header">
                                    <span className={`method-badge method-${endpoint.method.toLowerCase()}`}>
                                        {endpoint.method}
                                    </span>
                                    <span className="navigator-item-title">{endpoint.title}</span>
                                </div>
                                <div className="navigator-item-url">{endpoint.url}</div>
                            </Link>
                        );
                    })}
                </nav>
            </div>
        );
    }
}

